module.exports = __webpack_public_path__ + "img/beta.75bd2026.jpg";